
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("35AvZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7db93f72b5de291c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $dW37P = parcelRequire("dW37P");

var $fv0L0 = parcelRequire("fv0L0");

var $7mPT9 = parcelRequire("7mPT9");
const $7db93f72b5de291c$var$EMPTY_ENTRY_POINT_PARAMS = {};
const $7db93f72b5de291c$var$IssueSmartRequestSummaryTriggerOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isCompact: isCompact, totalComments: totalComments, hasComments: hasComments }, ref)=>{
    // The button is the trigger for loading the JsmSmartRequestSummary panel through this entrypoint context
    const issueSmartRequestSummaryEntryPoint = (0, $5uXOq.useContext)((0, $fv0L0.IssueSmartRequestSummaryEntryPointContext));
    const entryPointTriggerRef = (0, $47gW9.useEntryPointButtonTrigger)(issueSmartRequestSummaryEntryPoint.entryPointActions);
    const triggerRef = (0, $7mPT9.default)(ref, entryPointTriggerRef);
    // Button entrypoint - we load this in asynchronously
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $4mO32.useEntryPoint)((0, $dW37P.issueSmartRequestSummaryTriggerEntryPoint), $7db93f72b5de291c$var$EMPTY_ENTRY_POINT_PARAMS);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            totalComments: totalComments,
            hasComments: hasComments,
            triggerRef: triggerRef,
            isCompact: isCompact
        }), [
        totalComments,
        hasComments,
        isCompact,
        triggerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "issueSmartRequestSummaryTrigger",
        packageName: "issueActivityFeed",
        teamName: "Bento",
        fallback: null,
        errorFallback: "flag",
        runtimeProps: runtimeProps
    });
});
var $7db93f72b5de291c$export$2e2bcd8739ae039 = $7db93f72b5de291c$var$IssueSmartRequestSummaryTriggerOld;

});
parcelRegister("dW37P", function(module, exports) {

$parcel$export(module.exports, "issueSmartRequestSummaryTriggerEntryPoint", () => $ac029552970b6ad1$export$2e121e5cb0435aae);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $ac029552970b6ad1$export$2e121e5cb0435aae = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("lIsA0")).then((module)=>module.SmartRequestSummaryTrigger), {
        moduleId: "cf473c59"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lIsA0", function(module, exports) {

let $fcf3e0618c76a49a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fcf3e0618c76a49a$var$load("3CLw0").then(()=>parcelRequire('buOGu'));

});




//# sourceMappingURL=index-old.aac2ab73.js.map
